// extracted by mini-css-extract-plugin
export default {"cardHolder":"styles_cardHolder__VHuf1","title":"styles_title__RRlnj","icon":"styles_icon__WCSaA"};